import '../../../style/public.less';
import '../../transition/style';
import '../../carousel/style';
import '../../image/style';
import './index.less';